import React from 'react'
import defaultImg from './../../assets/img/preloaders/main.jpg'

const Imagen = (props) => {
  const backgroundImage = {
    backgroundImage: `url(${props.apiHome.bg_img_respiro ? props.apiHome.bg_img_respiro.sizes.lg : defaultImg})`
  }
  return (
    <section className="hero banner" style={backgroundImage}></section>
  )
}

export default Imagen;